import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=1fa75705&scoped=true&"
import script from "./Support.vue?vue&type=script&lang=js&"
export * from "./Support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa75705",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa75705')) {
      api.createRecord('1fa75705', component.options)
    } else {
      api.reload('1fa75705', component.options)
    }
    module.hot.accept("./Support.vue?vue&type=template&id=1fa75705&scoped=true&", function () {
      api.rerender('1fa75705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Support.vue"
export default component.exports